export default [
  {
    path: '/',
    name: 'root-login',
    component: () => import('@/pages/Login'),
    meta: {
      title: "登入",
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/login',
    name: 'user-login',
    component: () => import('@/pages/Login'),
    meta: {
      title: "登入",
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/auth/token',
    name: 'user-token-auth',
    component: () => import('@/pages/LoginAuth'),
    meta: {
      title: "登入校驗",
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/report/:reportId',
    name: 'user-report',
    component: () => import('@/pages/Report'),
    meta: {
      title: "量測報告",
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/report/:reportId/aiAnalysis',
    name: 'user-report-ai-analysis',
    component: () => import('@/pages/ReportAIAnalysis'),
    meta: {
      title: "AI分析報告",
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/report/:reportId/statistics',
    name: 'user-report-statistics',
    component: () => import('@/pages/ReportStatistics'),
    meta: {
      title: "量測歷史紀錄",
      requireAuth: false,
      isSupportMobile: true
    }
  },
  // 報告改版工單 18：新渲染器的元件展示頁（self-baseline 用）。只在 dev 建置註冊——條件是編譯期常數（同 $isDev()），
  // prod 建置整段被移除、bundle 不含此路由字串。chunk 名 report-gallery（與 renderer-next 分開：開新渲染器不會載到展示頁與
  // 圖表示範的 echarts 模組，dev 建置量新渲染器載入量時不被灌水；工單 18 站5）。
  ...(process.env.VUE_APP_SERVER === 'dev'
    ? [{
      path: '/report-gallery',
      name: 'report-gallery',
      component: () => import(/* webpackChunkName: "report-gallery" */ '@/report/gallery/ReportGallery.vue'),
      meta: {
        title: "報告元件展示",
        requireAuth: false,
        isSupportMobile: true
      }
    }]
    : []),
  {
    path: '/contest',
    redirect: '/admin/contest'
  },
  {
    path: '/appointment',
    redirect: '/admin/appointment'
  },
  {
    path: '/patient/:id',
    redirect: to => `/admin/patient/${to.params.id}`
  },
  {
    path: '/patient/:id/report',
    redirect: to => `/admin/patient/${to.params.id}/report`
  },
]